import { types, actions } from './requests'
export const SORTS_TYPES = {
    ...types('SORTS'),
}
export const SORTS_ACTIONS = {
    ...actions('SORTS'),
}